export const EVENT = {
  AI: {
    ALT_TEXT: {
      GENERATE: 'AI photo alt text - generate',
      KEEP: 'AI photo alt text - keep',
      REVERT: 'AI photo alt text - revert',
    },
    DESCRIPTION: {
      KEEP: 'AI description optimization - keep',
      OPTIMIZE: 'AI description optimization - optimize',
      RETRY: 'AI description optimization - retry',
      REVERT: 'AI description optimization - revert',
    },
    META_DESCRIPTION: {
      KEEP: 'AI meta description optimization - keep',
      OPTIMIZE: 'AI meta description optimization - optimize',
      RETRY: 'AI meta description optimization - retry',
      REVERT: 'AI meta description optimization - revert',
    },
    PAGE_TITLE: {
      KEEP: 'AI page title optimization - keep',
      OPTIMIZE: 'AI page title optimization - optimize',
      RETRY: 'AI page title optimization - retry',
      REVERT: 'AI page title optimization - revert',
    },
    PHOTOS: {
      GENERATE: 'AI photo generation - generate',
      KEEP: 'AI photo optimization - keep',
      OPTIMIZE: 'AI photo optimization - optimize',
      RETRY: 'AI photo optimization - retry',
      REVERT: 'AI photo optimization - revert',
      SELECT: 'AI photo generation - select',
    },
    TAGS: {
      ADD_MAXIMUM: 'AI tags optimization - add maximum',
      KEEP: 'AI tags optimization - keep',
      OPTIMIZE: 'AI tags optimization - optimize',
      REPLACE_ALL: 'AI tags optimization - replace all',
      RETRY: 'AI tags optimization - retry',
      REVERT: 'AI tags optimization - revert',
    },
    TITLE: {
      KEEP: 'AI title optimization - keep',
      OPTIMIZE: 'AI title optimization - optimize',
      RETRY: 'AI title optimization - retry',
      REVERT: 'AI title optimization - revert',
    },
  },
  PHOTO_EDITOR: {
    CLOSE_WITHOUT_SAVING: 'AI photo studio - close without saving',
    SAVE: {
      SAVE_NEW_PHOTO: 'AI photo studio - save as new photo',
      SAVE_NEW_VIDEO: 'AI photo studio - save as new video',
      UPDATE_CURRENT_PHOTO: 'AI photo studio - update current photo',
      UPDATE_CURRENT_VIDEO: 'AI photo studio - update current video',
    },
    TOOLS: {
      AI_EDIT: {
        EDIT: 'AI photo studio - edit',
        CLEANUP: 'AI photo studio - cleanup',
      },
      BACKGROUNDS: {
        GENERATE: 'AI photo studio - generate background',
        PROMPT_ASSIST: 'AI photo studio - prompt assist background',
        REMOVE: 'AI photo studio - remove background',
      },
      CROP: {
        CROP: 'AI photo studio - crop',
        EXPAND: 'AI photo studio - expand',
      },
      ENHANCE: {
        ENHANCE: 'AI photo studio - enhance',
      },
      IMAGE_TO_VIDEO: {
        GENERATE: 'AI photo studio - photo to video',
        PROMPT_ASSIST: 'AI photo studio - prompt assist photo to video',
      },
      LAYERS: {
        UPDATE: 'AI photo studio - update layers',
      },
    },
  },
};
